export default {
  sm: `
    나무와 풀로 
    지켜낸 생태축
  `,
  xxl: `
    나무와 풀로 지켜낸
    생태축
  `
};
